import React from "react";
import { DefaultDataTable } from "../../../components/dataTable/DefaultDataTable";

export const UsuarioList = props => <DefaultDataTable data={props} />;
